<template>
  <a-drawer
    :title="detail.remark_name"
    width="700"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <!-- from -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 平均单集时长 -->
      <a-form-item
        label="平均单集时长"
        name="duration"
        :rules="[{ required: true, validator: validatorInt }]"
      >
        <a-input
          v-model:value="formState.duration"
          placeholder="请输入"
          suffix="分钟"
        />
      </a-form-item>
      <!-- 快小题材 -->
      <a-form-item
        label="快小题材"
        name="ks_type"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.ks_type"
          placeholder="请选择"
          @change="onThemeTypeChange"
        >
          <a-select-option
            v-for="(item, index) in plotTags"
            :key="item.theme_type"
            :value="item.theme_type"
          >
            {{ item.type_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 快小主题 -->
      <a-form-item
        v-if="tagSubs.length"
        label="快小主题"
        name="ks_tag"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.ks_tag"
          mode="multiple"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :filterOption="filterOption"
        >
          <a-select-option
            v-for="item in tagSubs"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
            :disabled="!formState.ks_tag.includes(item.id) && formState.ks_tag.length >= 5"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 备案号 -->
      <!-- <a-form-item
        label="备案号"
        name="ordinary_record_num"
        :rules="[{ required: true }]"
      >
        <a-input
          v-model:value="formState.ordinary_record_num"
          placeholder="请输入"
        />
      </a-form-item> -->
      <!-- 制作机构 -->
      <a-form-item
        label="制作机构"
        name="production_organisation"
        :rules="[{ required: true }]"
      >
        <a-input
          v-model:value="formState.production_organisation"
          placeholder="请输入"
        />
      </a-form-item>
      <!-- 导演 -->
      <a-form-item
        label="导演"
        name="directors"
        :rules="[{ required: true }]"
      >
        <a-input
          v-model:value="formState.directors"
          placeholder="请输入，有多个使用顿号间隔，例如 A、B、C"
        />
      </a-form-item>
      <!-- 制作人 -->
      <a-form-item
        label="制作人"
        name="producer"
        :rules="[{ required: true }]"
      >
        <a-input
          v-model:value="formState.producer"
          placeholder="请输入，有多个使用顿号间隔，例如 A、B、C"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
    <!-- 预览 -->
    <PreviewModal ref="RefPreviewModal"></PreviewModal>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { nextTick } from 'process'
import Loading from '@/components/Loading'
import { ksSave, ksTags } from '@/api/copyright'
import PreviewModal from '@/components/preview/PreviewModal'
import { message, Modal } from 'ant-design-vue'
import Pub from '@/utils/public'
import Upload from '@/components/Upload'
import ImageView from '@/components/ImageView'

// 视频预览
let RefPreviewModal = ref(null)
// emit
const emit = defineEmits(['success'])
// from
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 详情
let detail = ref({})
// 剧情标签列表
let plotTags = ref([])
let tagSubs = ref([])
// 表单参数
const formState = reactive({
  // 平均单集时长
  duration: undefined,
  // 快小题材
  ks_type: undefined,
  // 快小主题
  ks_tag: [],
  // 备案号
  // ordinary_record_num: undefined,
  // 制作机构
  production_organisation: undefined,
  // 导演
  directors: undefined,
  // 制作人
  producer: undefined
})

// 显示
function showDrawer (data) {
  // 记录
  detail.value = data
  // 显示
  visible.value = true
  // 延迟处理
  nextTick(() => {
    // 赋值
    formState.duration = data.duration
    formState.ks_type = data.ks_type
    formState.ks_tag = data.ks_tag
    formState.production_organisation = data.production_organisation
    formState.directors = data.directors
    formState.producer = data.producer
    // formState.ordinary_record_num = data.ordinary_record_num
    // 获取标签
    getPlotTags()
  })
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    resetFields()
    visible.value = false
  }
}

// 重置
function resetFields () {
  RefForm.value.resetFields()
  tagSubs.value = []
  plotTags.value = []
}

// 准备上传（图片）
function beforeUploadPro (file) {
  if (!file.type.includes('image')) {
    message.error('请上传图片类型的文件')
    return false
  }
  return true
}

// 上传结果
function uploadResult (key, fileJson, res, record) {
  // 上传结果判断
  if (fileJson.status === 'done') {
    RefForm.value.validate()
    formState[key] = [fileJson]
  }
}

// 图片校验
function validatorImage (rule, value) {
  // 图片
  if (value && value.length === 0) {
    return Promise.reject('请上传')
  }
  // 都通过
  return Promise.resolve()
}

// 移除封面
function touchDeleteCover (coverKey, index) {
  formState[coverKey].splice(index, 1)
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then((res => {
    // 上传数据
    const params = {
      ks_drama_id: detail.value && detail.value.ks_drama_id,
      id: detail.value && detail.value.id,
      ...res,
    }
    isLoading.value = true
    // 创建
    ksSave(params).then((res) => {
      isLoading.value = false
      const { code, data } = res
      if (code === 0) {
        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        Modal.error({
          title: '操作错误',
          content: res.message
        })
      }
    }).catch(() => {
      isLoading.value = false
      Modal.error({
        title: '操作错误',
        content: '保存失败'
      })
    })
  })).catch((err) => {
    console.log(err)
  })
}

// 获取标签列表
function getPlotTags () {
  const params = {
    page: 1,
    page_size: 10000
  }
  ksTags(params).then(res => {
    const { code, data } = res
    if (code === 0) {
      plotTags.value = data
      findTagSubs()
    }
  })
}

// 主题切换
function onThemeTypeChange () {
  formState.ks_tag = []
  findTagSubs()
}

function findTagSubs () {
  const item = plotTags.value.find((item) => { return item.theme_type === formState.ks_type })
  tagSubs.value = item && item.theme_list || []
}

// 效验正整数
function validatorInt (rule, value) {
  if (!value) {
    return Promise.reject('请输入${label}')
  } else if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  }
  return Promise.resolve()
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.form-input {
  width: 50%;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
}
.image-view.upload-image {
  height: 148px;
}
.sync-tt {
  padding-top: 6px;
  font-size: 12px;
  color: rgba(232, 230, 227, 0.45);
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
// .form-upload-item {
//   margin-top: 10px;
//   margin-left: 10px;
//   position: relative;
//   width: 118px;
//   height: 148px;
//   border-radius: 4px;
//   overflow: hidden;
//   img {
//     display: inline-block;
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
//   &.horizontal {
//     width: 148px;
//     height: 118px;
//   }
// }
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
  height: 148px;
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
</style>